<div [class.hidden]="!show">
  <div class="start-loader-overlay" *ngIf="show">
    <div class="start-loader"></div>
  </div>
</div>
